<template>
  <div>
    <BaseOutline class="max-w-3xl mx-auto">
      <div class="relative bg-white mx-auto max-w-3xl rounded-box">
        <div
          class="relative flex flex-col justify-center px-6 py-16 text-center md:px-14 md:py-28 z-[1]"
        >
          <h2
            class="mx-auto mb-6 text-3xl font-extrabold tracking-tight md:mb-8 md:text-4xl"
          >
            {{ $t('landing.lastBlock.title') }}
          </h2>
          <div
            class="text-gray-600 mx-auto mb-8 max-w-[31rem] leading-relaxed md:mb-12 md:text-xl"
          >
            <p>
              {{ $t('landing.lastBlock.subtitle') }}
            </p>
          </div>

          <div class="w-full gap-8 flex flex-col">
            <BaseButton
              class="max-w-[250px] mx-auto"
              color="primary-gradient"
              :to="{ name: 'signin' }"
            >
              <span>{{ $t('landing.lastBlock.startLearning') }}</span>
            </BaseButton>

            <BaseHappy class="mx-auto" />
          </div>
        </div>

        <img
          src="/images/capybara-head-lightgray.png"
          class="absolute bottom-0 left-0 size-[200px] sm:size-[300px] opacity-50 rotate-[36deg] translate-x-[-100px] translate-y-[40px] pointer-events-none"
          loading="lazy"
          fetchpriority="high"
          style="filter: brightness(0.95)"
          :alt="$t('footer.capybaraAlt')"
        />
      </div>
    </BaseOutline>
  </div>
</template>

<script>
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseOutline from '@/components/Base/BaseOutline.vue'
import BaseHappy from '@/components/Base/BaseHappy.vue'

export default {
  name: 'LandingLastBlock',

  components: { BaseOutline, BaseButton, BaseHappy }
}
</script>
